export const homeObjOne = {
  primary: true,
  lightBg: false,
  lightTopLine: true,
  lightText: true,
  lightTextDesc: true,
  topLine: 'CookiBite',
  headline: 'The best cookies that you can taste',
  description:
    'See what make us different.',
  buttonLabel: 'Get Started',
  imgStart: '',
  img: require('../../images/svg-intro.svg'),
  alt: 'Credit Card',
  start: ''
};

export const homeObjTwo = {
  primary: true,
  lightBg: false,
  lightTopLine: true,
  lightText: true,
  lightTextDesc: true,
  topLine: 'Our Vision',
  // ! This is a typo error
  headline: 'Hacer productos que deleiten hasta al más fino gusto',
  // ! This text is not exactly what CookieBites does
  description:
    "We will make our products and services impact by improving and facilitating the lives of our clients through our competitiveness, innovation and customization, thus becoming a STANDARD. Achieving high satisfaction and good service to our customers.",
  buttonLabel: 'Learn More',
  imgStart: '',
  img: require('../../images/svg-7.svg'),
  alt: 'Vault',
  start: ''
};

export const homeObjThree = {
  primary: false,
  lightBg: true,
  lightTopLine: false,
  lightText: false,
  lightTextDesc: false,
  topLine: 'Las mejor receta',
  // ! This is a typo error
  headline:
    'What is insiede out cookies?',
  // ? Beautiful?
  description:
    "CookieBites is an initiative dedicated to the development and manufacture of the most beautiful cookies.",
  buttonLabel: 'View Case Study',
  imgStart: 'start',
  img: require('../../images/svg-6.svg'),
  alt: 'Vault',
  start: 'true'
};

export const homeObjFour = {
  primary: true,
  lightBg: false,
  lightTopLine: true,
  lightText: true,
  lightTextDesc: true,
  // ! This is an error of copy paste
  topLine: 'All your data is stored on our servers',
  headline: 'Get Your Files Everywhere',
  description:
    'We store the files you want to add to our cloud service, thus you can access them from your computer or your phone.',
  buttonLabel: 'Sign Up Now',
  imgStart: 'start',
  img: require('../../images/svg-3.svg'),
  alt: 'Vault',
  start: 'true'
};
